// Shared GET helper for list endpoints.
//
// Exists because every Get in the app was the same six unguarded lines:
//
//     fetch(url, {...}).then(res=>res.json()).then(data => setValues(data.response));
//
// which has three failure modes, all silent:
//   1. network failure      -> promise rejects, setValues never runs
//   2. non-2xx with JSON     -> data.response is undefined, so setValues(undefined) is called
//                               and the table's filterList.length throws -> white screen
//   3. non-2xx with HTML      -> res.json() rejects, same as (1)
//
// (2) became reachable when the permission guard started returning 403 with a JSON body
// instead of a bare 401.
//
// That was survivable while the tables showed "No data available" on an empty list, because
// every outcome looked the same. It is NOT survivable with a loading state: a request that
// never resolves leaves the shimmer spinning forever. So the contract here is:
//
//     onData is ALWAYS called exactly once, with an array.
//
// Callers can therefore clear their loading flag inside onData and know it will fire.
const readToken = () => {
    // Module-scope `JSON.parse(localStorage.getItem("user-info"))` throws when the key is
    // missing, which is why this is wrapped and read per call rather than once at import.
    try {
        const user = JSON.parse(localStorage.getItem("user-info"));
        return user && user.token ? user.token : '';
    } catch (e) {
        return '';
    }
};

// onData(list, meta) - `meta` is the full response body, for callers that also need
// pagination fields (total/pages/page). It is {} when the request failed.
export const apiGetList = (url, onData) => {
    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + readToken()
        }
    })
    .then((res) => res.ok ? res.json() : null)
    .catch(() => null)
    .then((body) => {
        const list = body && Array.isArray(body.response) ? body.response : [];
        onData(list, body || {});
    });
};

export default apiGetList;
